import React, { Children, useContext } from 'react';
import Button from './Button';
import ModalMessage from '../modal/ModalMessage';
import { ModalContext } from '../../hooks';

export default function Info({ title, children }) {
    let Modals = useContext(ModalContext);

    return <Button className="info" onClick={()=>Modals.create(ModalMessage,{title, render:children})}><div>?</div></Button>
}